export const PALETTES = [
    'default',
    'polaroid',
    'editorial',
    'claymorphism',
    'botanical',
    'bauhaus',
    'brutalist',
    'risograph',
    'cyber',
    'y2k',
    'terminal',
];
/**
 * Some palettes are inherently tied to a base theme — Cyber Neon's
 * neon glow + Terminal's CRT vibe only read in dark, Y2K's iridescent
 * pastel only reads in light. When the user picks one of these we
 * clamp the rendered theme to its locked value (the stored
 * `User.theme` is preserved so unpicking restores their preference).
 */
export const PALETTE_FORCED_THEME = {
    cyber: 'dark',
    terminal: 'dark',
    y2k: 'light',
};
export const ANIMATIONS = [
    'none',
    'dust',
    'petals',
    'orbits',
    'clay_blobs',
    'paper_grain',
    'marquee',
    'ink_blobs',
    'neon_grid',
    'matrix_rain',
    'holo_blobs',
];
